import {
    ApolloClient,
    InMemoryCache,
    type NormalizedCacheObject,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";

export function createBackendClient(
    endpoint: string,
    apiKey: string,
): ApolloClient<NormalizedCacheObject> {
    const uploadLink = createUploadLink({ uri: endpoint });

    const authLink = setContext((_, { headers }) => ({
        headers: {
            ...headers,
            Authorization: `ApiKey ${apiKey}`,
        },
    }));

    return new ApolloClient({
        link: authLink.concat(uploadLink),
        cache: new InMemoryCache(),
    });
}
